/**
 * Benefit 福利相关接口操作类
 *
 * @module BenefitAPI
 * @since 1.0.0
 * @version 1.0.0
 */

import http from './http'

/**
 * @class BenefitAPI
 */
export default class BenefitAPI {
  /**
   * 根据code查询福利信息
   * @param {object} options - http 请求参数
   * @param {string} options.code - 福利代码
   * @returns {Promise} - 返回操作后的 Promise
   */
  static queryInfoByCode(options = {}) {
    return http.post({
      ...options,
      url: `/activity/v1/bumper/queryInfoByCode`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  /**
   * 增加碰碰贴内容点击次数
   * @param {object} options - http 请求参数
   * @param {number} options.bumperStickerId - 碰碰贴ID
   * @param {number} options.businessChannel - 业务渠道
   * @param {number} options.tenantId - 租户ID
   * @returns {Promise} - 返回操作后的 Promise
   */
  static clickCount(options = {}) {
    return http.post({
      ...options,
      url: `/activity/v1/bumper/log/addClickCount`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  /**
   * 获取豆包临时key
   */
  static getDoubaoTempKey(options = {}) {
    return http.get({
      ...options,
      url: `/activity/v1/bumper/getDoubaoTempKey`,
    })
  }

  /**
   * 根据碰碰贴详情ID获取AI提示词
   */
  static getAiPrompt(options = {}) {
    const { bumperStickerDetailId, ...restOptions } = options

    return http.get({
      ...restOptions,
      url: `/activity/v1/bumper/getAiPrompt/${bumperStickerDetailId}`,
    })
  }
}
